import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//MUI
import makeStyles from '@material-ui/core/styles/makeStyles';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

//ICONS
//DS
import IconSwap from '../IconSwap';
import Item from './Item';
import {hidden} from '../../../common/helpers';
//ESTILOS
const useStyles = makeStyles((theme) => ({
   root: {
      paddingTop: 0,
      paddingBottom: 0
   }
}));
/**
 * Representacion grafica de un arbol(lista de multiples niveles) con nodos anidados uno dentro de otro de acuerdo a las propiedades proporcionadas.
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [List](https://material-ui.com/api/list/).
 */
function ListaMultiNivel({
   arbol,
   mapaArbol,
   itemComponent,
   onItemClick,
   className,
   contraerTodos,
   hide,
   ...rest
}) {
   const classes = useStyles();
   const isHideFuntion = typeof hide === 'function';
   function hideFunction(item) {
      if (isHideFuntion) {
         return hide(item);
      }
      return false;
   }
   //Control de expacion de la lista
   const [open, setOpen] = useState(false);
   function handleClick() {
      setOpen(!open);
      if (onItemClick) {
         onItemClick(arbol);
      }
   }
   useEffect(() => {
      if (contraerTodos) {
         setOpen(false);
      }
   }, [contraerTodos]);
   //Control de propiedades de la lista superior
   const {
      [mapaArbol.titulo]: titulo,
      [mapaArbol.icono]: icono,
      [mapaArbol.nodos]: nodos,
      ...nodoExtraProps
   } = arbol;

   if (hidden(nodoExtraProps)) {
      return null;
   }
   if (hideFunction(arbol)) {
      return null;
   }
   return (
      <List {...rest} className={clsx(classes.root, className)}>
         <ListItem button onClick={handleClick}>
            {icono && <ListItemIcon style={{minWidth: '50px'}}>{icono}</ListItemIcon>}
            <ListItemText primary={titulo} />
            {nodos && nodos.length > 0 && <IconSwap swap={open} />}
         </ListItem>
         {nodos && nodos.length > 0 && (
            <Collapse in={open} timeout="auto" unmountOnExit>
               <List component="div" disablePadding>
                  {nodos.map((item, index) => (
                     <Item
                        key={index}
                        arbol={item}
                        mapaArbol={mapaArbol}
                        itemComponent={itemComponent}
                        onItemClick={onItemClick}
                        contraerTodos
                        hide={hideFunction}
                     />
                  ))}
               </List>
            </Collapse>
         )}
      </List>
   );
}

ListaMultiNivel.propTypes = {
   /**
    * Arbol con nodos anidados uno dentro de otro.
    */
   arbol: PropTypes.object.isRequired,
   /**
    * Equivalencia de las propiedades usadas por el componente y las proporcionados por los nodos de los `arboles`, donde:
    *
    * - `titulo`: Propiedad de los nodos de los `arboles` que contine el texto del item de la lista.
    * - `icono`: Propiedad de los nodos de los `arboles` que contine el icono del item de la lista.
    * - `nodos`: Propiedad de los nodos de los `arboles` que contine los nodos o hijos del nodo.
    *
    * Cualquier otra propiedad sera pasada al componente proporcionado por itemComponent en el atributo itemprops.
    */
   mapaArbol: PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      icono: PropTypes.string.isRequired,
      nodos: PropTypes.string.isRequired
   }),
   /**
    * Elemento que renderizara los item hojas de la lista, este componente recibira las propiedades adicionales nod definidad en `mapaArbol`.
    */
   itemComponent: PropTypes.elementType,
   /**
    * Si es __true__, todos los item que pueden contraerse se contraeran.
    */
   contraerTodos: PropTypes.bool,
   /** Función que determina si un node es visible, con la siguiente firma:
    *
    * - `arbol`: objeto, con la misma forma a los del array de la propiedad __arbol__.
    * - `retorno`: boolean, si es __true_ el nodo no sera renderizado.
    * */
   hide: PropTypes.func
};
ListaMultiNivel.defaultProps = {
   mapaArbol: {
      titulo: 'titulo',
      icono: 'icono',
      nodos: 'nodos'
   }
};
export default ListaMultiNivel;
